import React from 'react';
import { useSelector } from 'react-redux';
import { selectIsMobileMQ } from 'core/modules/MediaQueries/selectors';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';

import ToggleBanner from './components/ToggleBanner';
import StaticBanner from './components/StaticBanner';

import './AcquisitionBonusBanner.scss';

function AcquisitionBonusBanner() {
  const isMobileMQ = useSelector(selectIsMobileMQ);

  return isMobileMQ ? <ToggleBanner /> : <StaticBanner />;
}

export default (props) => <ComponentErrorBoundary><AcquisitionBonusBanner {...props} /></ComponentErrorBoundary>;
